import Colors from '../../config/Colors';
import styled from 'styled-components';
import styledNative from 'styled-components';
import TextComponent from '../textComponent';

export const modalContentConfig = {
    height: 'auto',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    overflow: 'hidden'
};

export const ModalContent = styled.div`
    height: auto;
`;

export const Header = styled.div`
    display: flex;
    flex-direction: row;
    height: 25px;
    justify-content: space-between;
    border-bottom: 1px solid ${Colors.border};
    padding-bottom: 16px;
`;

export const Body = styled.div`
    display: flex;
    flex-direction: column;
    padding: 25px 10px;
    height: auto;
`;

export const Footer = styled.div`
    display: flex;
    flex-direction: row;
    height: 44px;
    margin-top: auto;
    justify-content: flex-end;
    border-top: 1px solid ${Colors.border};
    padding-top: 16px;
`;

export const Title = styledNative(TextComponent)`
    font-size: 18px;
`;

export const CloseButtonIcon = styled.button`
    width: 25;
    height: 25;
    background-color: ${Colors.regular};
    border-radius: 50%;
    border: 1px solid ${Colors.border};
    align-items: center;
    justify-content: center;
    padding: 2px;
    cursor: pointer;
`;
